if (!window.customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.enable = !sessionStorage.getItem('announcementBarClosed');
    }
  
    initializeSwiper() {
      requestAnimationFrame(() => {
        const swiperEl = this.querySelector('swiper-container');
        const swiperParams = {
          slidesPerView: swiperEl.getAttribute('slides-per-view') || 1,
          speed: 1500,
          gap: 0,
          autoplay: {
            delay: 4000,
            disableOnInteraction: true,
          },
          breakpoints: {
            1280: {
              slidesPerView: swiperEl.getAttribute('slides-per-view-tablet') || 2
            },
            1440: {
              slidesPerView: swiperEl.getAttribute('slides-per-view-desktop') || 3
            }
          },
          loop: true,
        };
        
        Object.assign(swiperEl, swiperParams);
        swiperEl.initialize();
      });
    }
  
    handleClose() {
      this.setAttribute('aria-hidden', true);
      sessionStorage.setItem('announcementBarClosed', true);
    }
  
    connectedCallback() {
      if (!this.enable) return;
      
      document.addEventListener("DOMContentLoaded", () => {
        this.setAttribute('aria-hidden', false);
        this.initializeSwiper();
      })
  
      const closeButton = this.querySelector('.announcement-close')
      if (closeButton) {
        closeButton.addEventListener('click', () => this.handleClose());
        if (window.scrollY < 50) this.scrollIntoView({ behavior: 'smooth', block: "start" });
      }
    }
  }
  
  customElements.define('announcement-bar', AnnouncementBar);
}